import {pipeFunctions} from '../helpers';
import {
    getEventName,
    transformCarouselDataToEventFields,
    triggerEdapEvent,
} from './edapHelpers';
import {
    CAROUSEL_TYPES,
    EVENT_SPECIFIC_ATTRIBUTES,
    EVENT_TYPES,
} from './edapEventsConstants';

const createEvent = (eventType) => (carouselType) =>
    pipeFunctions(
        getEventName(eventType, carouselType),
        transformCarouselDataToEventFields(
            EVENT_SPECIFIC_ATTRIBUTES[eventType]
        ),
        triggerEdapEvent
    );

const createPresentedEvent = createEvent(EVENT_TYPES.PRESENTED);
const createSelectedEvent = createEvent(EVENT_TYPES.SELECTED);
const createUpdatedEvent = createEvent(EVENT_TYPES.UPDATED);

export const carouselEvents = {
    [CAROUSEL_TYPES.PROPERTY]: {
        [EVENT_TYPES.PRESENTED]: createPresentedEvent(CAROUSEL_TYPES.PROPERTY),
        [EVENT_TYPES.UPDATED]: createUpdatedEvent(CAROUSEL_TYPES.PROPERTY),
        [EVENT_TYPES.SELECTED]: createSelectedEvent(CAROUSEL_TYPES.PROPERTY),
    },

    [CAROUSEL_TYPES.DESTINATION]: {
        [EVENT_TYPES.PRESENTED]: createPresentedEvent(
            CAROUSEL_TYPES.DESTINATION
        ),
        [EVENT_TYPES.UPDATED]: createUpdatedEvent(CAROUSEL_TYPES.DESTINATION),
        [EVENT_TYPES.SELECTED]: createSelectedEvent(CAROUSEL_TYPES.DESTINATION),
    },
};
